import React, { useContext, useMemo, useState, useEffect } from 'react';
import Link from 'next/link';
import { isEmpty, sample } from 'lodash';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { deviceType } from 'react-device-detect';
import {
  Box,
  Flex,
  Text,
  Image,
  Divider,
  Button,
  Input,
  Spinner,
  IconButton,
  SimpleGrid,
  useDisclosure,
  Icon,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  useColorMode,
} from '@chakra-ui/react';
import { Modal, ModalOverlay, ModalContent, ModalBody } from '@chakra-ui/react';
import { priceStx, price as priceUsd, shareOnFacebook, shareOnTwitter } from 'utils/utility';
import { getStxAddress, truncate } from 'lib/utility';
import { AuthContext } from 'contexts/auth/auth.context';
import notification from 'components/Notifications';
import { authenticate, purchaseNFTLayer, userSession } from 'utils/stacks';
import { API } from 'config/api';
import { useRouter } from 'next/router';
import ReactJwPlayer from 'react-jw-player';
import PowerBy from 'components/PowerBy';
import { bgColor } from 'config/data';
import axios from 'axios';
import { useAuthDispatch } from 'contexts/0Auth';

const Step1 = ({
  setStep,
  data = {},
  access_token,
  currentUser,
  quantity,
  onUpdate,
  updated,
  loading,
  intentUsd,
  intentStx,
  collection,
  meta,
  onPaginate,
  transactions,
  isLoading,
}) => {
  // console.log('meta', meta);
  const [image, setImage] = useState(null);
  const [device, setDevice] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  // console.log('intentUsd', intentUsd);
  // console.log('intentStx', intentStx);
  const { id, price, user } = data;
  const { authDispatch } = useContext(AuthContext);
  const { goToOauth } = useAuthDispatch();
  const router = useRouter();
  const pathname = router.asPath;

  const { colorMode } = useColorMode();

  const onGoToAuth = async () => {
    await axios.post('/api/current', { pathname });
    goToOauth();
  };

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      setDevice(deviceType);
    }
    return () => (isSubscribed = false);
  }, []);

  const onPayUsd = async () => {
    if (currentUser?.isLoggedIn) {
      setStep(2);
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      // authDispatch({ type: 'SHOW_MODAL', path: router.asPath });
      onGoToAuth();
    }
  };

  const debouncedSave = useMemo(
    () =>
      debounce((val) => {
        onUpdate(Number(val));
        // router.query.quantity = val;
        // router.replace(router);
      }, 500),
    []
  );

  const onOpenModal = (image) => {
    setImage(image);
    onOpen(true);
  };

  const onPayStx = async () => {
    if (currentUser?.isLoggedIn) {
      // Intent STX
      const config = { headers: { Authorization: `Bearer ${access_token}` } };
      API.post(`nft/mintPool/${id}/intent`, { method: 'stx', quantity }, config)
        .then((res) => {
          const intent = res.data.data.stx_transfer;
          // console.log('intent', intent);
          const amount = intent.amount; // intent.amount
          const memo = intent.memo; // intent.memo
          if (userSession.isUserSignedIn()) {
            const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
            p.then((txId) => {
              const dataPurchase = {
                intent: intent?.intent_token,
                transaction_id: txId,
                method: 'stx',
              };
              API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
                .then(() => setStep(3))
                .catch((err) => notification('error', `❌${err.response.data.message}`));
            });
          } else {
            authenticate(() => {
              const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
              p.then((txId) => {
                const dataPurchase = {
                  intent: intent?.intent_token,
                  transaction_id: txId,
                  method: 'stx',
                };
                API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
                  .then(() => setStep(3))
                  .catch((err) => notification('error', `❌${err.response.data.message}`));
              });
            });
          }
        })
        .catch((err) => notification('error', `❌${err.response.data.message}`));
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      onGoToAuth();
    }
  };

  const onPayStxUpdated = async () => {
    console.log('aqui');
    if (currentUser?.isLoggedIn) {
      const intent = intentStx;
      console.log('intent', intent);
      const amount = intent.amount; // intent.amount
      const memo = intent.memo; // intent.memo
      if (userSession.isUserSignedIn()) {
        const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
        p.then((txId) => {
          const dataPurchase = {
            intent: intent?.intent_token,
            transaction_id: txId,
            method: 'stx',
          };
          API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
            .then(() => setStep(3))
            .catch((err) => notification('error', `❌${err.response.data.message}`));
        });
      } else {
        authenticate(() => {
          const p = new Promise((resolve, reject) => purchaseNFTLayer(amount, memo, resolve));
          p.then((txId) => {
            const dataPurchase = {
              intent: intent?.intent_token,
              transaction_id: txId,
              method: 'stx',
            };
            API.post(`/nft/mintPool/${id}/purchase`, dataPurchase, config)
              .then(() => setStep(3))
              .catch((err) => notification('error', `❌${err.response.data.message}`));
          });
        });
      }
    } else {
      // authDispatch({ type: 'SHOW_MODAL' });
      await axios.post('/api/current', { pathname });
      goToOauth();
    }
  };

  const randomNft = sample(collection);

  const url =
    process.env.NEXT_PUBLIC_ENV === 'staging'
      ? `https://staging.heylayer.com/mintpool/${id}`
      : `https://heylayer.com/mintpool/${id}`;

  return (
    <Flex mt="40px" flexDirection={{ base: 'column', md: 'row' }} minH="85vh" alignItems="center" id="content">
      <Modal size="2xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent p="20px 5px">
          {/* <ModalCloseButton /> */}
          <ModalBody>
            <Image src={image} alt="" />
          </ModalBody>
        </ModalContent>
      </Modal>

      <Box id="info" mb="20px">
        <Text fontWeight="500" mb="15px" fontSize="15px">
          Duckdown NFTs powered by UPG presents:
        </Text>
        <Text
          fontSize={{ base: '50px', md: '72px' }}
          textTransform="uppercase"
          fontWeight="900"
          fontFamily="Lexend Exa"
          lineHeight="1.1em"
        >
          I am <br />
          the boss
        </Text>
        <Text fontWeight="extrabold" mt="15px" mb="30px" fontSize="16px">
          <Text as="span" fontWeight="normal" mr="4px">
            by
          </Text>{' '}
          Buckshot &quot;The coolest in crypto&quot;
        </Text>
        <Box
          p="20px"
          borderWidth={colorMode === 'dark' ? 0 : 1}
          borderRadius={8}
          w={{ base: '100%', md: '440px' }}
          bg={bgColor[colorMode]}
        >
          <Text fontWeight="bold" mb="14px">
            NFT Featuring:
          </Text>
          <Box>
            <Flex mb="10px">
              <Image src="/images/icon_mint_pool.png" alt="" alignSelf="center" mr="10px" />
              <Text>
                <b>3</b> audio tracks
              </Text>
            </Flex>
            <Flex mb="10px">
              <Image src="/images/icon_mint_pool.png" alt="" alignSelf="center" mr="10px" />
              <Text>
                <b>1</b> video track
              </Text>
            </Flex>
            <Flex mb="10px">
              <Image src="/images/icon_mint_pool.png" alt="" alignSelf="baseline" pt="6px" mr="10px" />
              <Text lineHeight="2.19">
                <b>4</b> 3D assets & images, and ongoing utility value through unified city metaverse events
              </Text>
            </Flex>
          </Box>
        </Box>
      </Box>

      <Box w={{ base: '100%', md: '400px' }} m="0 auto" id="card">
        <Flex flexDirection="column" pos="relative" mb="20px" justifyContent="center" alignItems="center" w="100%">
          <Flex flexDir="column" zIndex={10} justifyContent="center" alignItems="center" w="100%">
            <Box bg="#fff" w="100%">
              <Box pos="relative" zIndex={1}>
                <ReactJwPlayer
                  playerId="fcTlemw5"
                  playerScript="https://content.jwplatform.com/libraries/fcTlemw5.js"
                  playlist={[
                    {
                      sources: [
                        {
                          default: false,
                          type: 'mp4',
                          file: '/images/Buckshot_NFT_Collection_showcase.mp4',
                          label: '0',
                        },
                      ],
                    },
                  ]}
                  primary="html5"
                />
              </Box>

              <Flex
                pos="relative"
                flexDirection="column"
                id="title"
                bg={bgColor[colorMode]}
                // borderRadius={8}
                borderWidth={colorMode === 'dark' ? 0 : 1}
                p="10px 20px 30px"
                zIndex={2}
              >
                <Flex id="price_quantity" justifyContent="space-between" mb="8px">
                  <Text fontSize="14px">Price</Text>
                  <Text fontSize="14px">Quantity</Text>
                </Flex>

                {loading ? (
                  <Flex p="7px 15px" justifyContent="center">
                    <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="blue.500" size="xl" />
                  </Flex>
                ) : (
                  <Flex
                    id="price_input"
                    bg={colorMode === 'dark' ? '#0e0e0e' : '#ececec'}
                    borderRadius={24}
                    borderWidth={1}
                    borderColor={colorMode === 'dark' ? '#333' : null}
                    justifyContent="space-between"
                  >
                    <Flex id="price" color={colorMode === 'dark' ? '#fff' : '#020303'} alignItems="center" ml="15px">
                      <Text fontWeight="bold" fontSize="20px" mr="7px">
                        {price?.usd && priceUsd(updated ? intentUsd?.amount / 100 : price?.usd / 100)} USD{' '}
                      </Text>
                      <Text fontSize="14px">
                        / {price?.micro_stacks && priceStx(updated ? intentStx?.amount : price?.micro_stacks)}{' '}
                      </Text>
                    </Flex>
                    <Flex>
                      <Input
                        borderRadius="5px 24px 24px 5px"
                        bg="#fff"
                        w="62px"
                        size="lg"
                        defaultValue={quantity}
                        type="number"
                        _placeholder={{ color: '#7f7f7f', fontSize: '14px' }}
                        _invalid={{ borderColor: '#e53e3e' }}
                        _focus={{ borderColor: '#000' }}
                        _disabled={{ color: 'gray.500' }}
                        color="#141416"
                        fontWeight="500"
                        onChange={(e) => debouncedSave(e.target.value)}
                      />
                    </Flex>
                  </Flex>
                )}

                <Divider my="20px" borderColor={colorMode === 'dark' ? '#333' : null} />

                <Button
                  bg="#316cf4"
                  variant="black"
                  w="100%"
                  mb="15px"
                  size="lg"
                  fontSize="16px"
                  onClick={() => onPayUsd()}
                >
                  Pay USD By Credit Card
                </Button>
                <Button
                  variant="black"
                  bg={colorMode === 'dark' ? '#fff' : null}
                  color={colorMode === 'dark' ? '#141414' : null}
                  borderColor="#020303"
                  w="100%"
                  size="lg"
                  onClick={() => (updated ? onPayStxUpdated() : onPayStx())}
                >
                  Pay with STX
                </Button>
              </Flex>
            </Box>
          </Flex>
        </Flex>
      </Box>

      <Box
        pos={{ base: 'relative', md: 'absolute' }}
        mt={{ base: '14px', md: 0 }}
        bottom="40px"
        left={{ base: 0, md: '40%' }}
      >
        <PowerBy />
      </Box>
    </Flex>
  );
};

export default Step1;
